import { useEffect, useMemo, useState } from "react";
import SupervisorApi from "../apis/supervisorApi";
import { isAutotask, isConnectWise, isHalo } from "../utils/mspUtils";

function labelsFromOptions(response: { statusOptions?: Array<{ label?: string }> } | null | undefined): string[] {
  const options = response?.statusOptions;
  if (!Array.isArray(options)) {
    return [];
  }
  return Array.from(
    new Set(options.map((option) => String(option?.label || "").trim()).filter(Boolean))
  );
}

/** PSA status names for the Service Desk filter. Does not query tickets. */
export function usePsaTicketStatusOptions(mspType?: string): string[] {
  const [catalog, setCatalog] = useState<string[]>([]);
  const supervisorApi = useMemo(() => new SupervisorApi(), []);

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      if (!mspType || (!isAutotask(mspType) && !isHalo(mspType) && !isConnectWise(mspType))) {
        if (isMounted) setCatalog([]);
        return;
      }
      try {
        const response = isAutotask(mspType)
          ? await supervisorApi.getTicketStatusOptions()
          : await supervisorApi.getTicketCreateOptions();
        if (isMounted) setCatalog(labelsFromOptions(response));
      } catch (error) {
        console.error("Failed to load ticket status options:", error);
        if (isMounted) setCatalog([]);
      }
    };
    load();
    return () => {
      isMounted = false;
    };
  }, [mspType, supervisorApi]);

  return catalog;
}
